module.exports = __webpack_public_path__ + "img/10.230c959d.png";